import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID,
  Renderer2,
  ElementRef,
} from '@angular/core';
import { AuthService } from '../../pages/shared/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router, RouterLink } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [TranslateModule, CollapseModule, CommonModule, RouterLink],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  isCollapsed = {
    Experiences: true,
    Maker: true,
    Taker: true,
    Reseller: true,
    MiWeb: true,
  };

  public iconOnlyToggled = false;
  isAdmin = false;
  public activeLang = 'es';

  constructor(
    public authService: AuthService,
    public translate: TranslateService,
    public router: Router,
    public location: Location,
    private renderer: Renderer2,
    private elem: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    router.events.subscribe((val) => {
      if (
        location.path().indexOf('/' + this.activeLang + '/maker/admin/') ===
          0 ||
        location.path().indexOf('/' + this.activeLang + '/taker/admin/') ===
          0 ||
        location.path().indexOf('/' + this.activeLang + '/reseller/admin/') ===
          0
      ) {
        this.isAdmin = true;
      }
    });
    this.activeLang = location.path().substring(1, 3);
    this.translate.setDefaultLang(
      this.activeLang === 'ev' ? 'es' : this.activeLang
    );
  }

  ngOnInit(): void {
    const body = this.elem.nativeElement.ownerDocument.body;

    const navItems =
      this.elem.nativeElement.querySelectorAll('.sidebar .nav-item');
    navItems.forEach((el: HTMLElement) => {
      this.renderer.listen(el, 'mouseover', () => {
        if (body.classList.contains('sidebar-icon-only')) {
          this.renderer.addClass(el, 'hover-open');
        }
      });
      this.renderer.listen(el, 'mouseout', () => {
        if (body.classList.contains('sidebar-icon-only')) {
          this.renderer.removeClass(el, 'hover-open');
        }
      });
    });
  }

  // toggle sidebar
  toggleSidebar() {
    const body = this.elem.nativeElement.ownerDocument.body;
    this.iconOnlyToggled = !this.iconOnlyToggled;
    if (this.iconOnlyToggled) {
      body.classList.add('sidebar-icon-only');
    } else {
      body.classList.remove('sidebar-icon-only');
    }
  }

  getMaker() {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    return JSON.parse(localStorage.getItem('maker')).id;
  }
}
